export default "__VITE_ASSET__CqcY80gc__"